import { Component, inject, Input, OnInit } from '@angular/core';
import { SubscriptionTracker } from 'src/app/shared/utilities/subscription-tracker';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
    VizHeaderComponent,
    VizHeaderMenuItemSelectedEvent,
    VizHeaderMenusConfig
} from '@vizientinc/design-system-toolkit';

const SUPPORT_EMAIL = 'suppliertraining@vizientinc.com';
const HELP_EMAIL_ITEM_TEXT = `Email: ${SUPPORT_EMAIL}`;
const HELP_RESOURCES_ITEM_TEXT = 'Supplier Resources and Help';
const BID_REGISTRATION_ITEM_TEXT = 'Bid Registration';
const HELP_ICON = 'help';
const APPS_ICON = 'apps';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        CommonModule,
        VizHeaderComponent,
    ]
})
export class HeaderComponent extends SubscriptionTracker implements OnInit {

    private router = inject(Router);

    @Input() appTitle!: string;
    headerVisible = true;
    brandLink = '';
    headerMenus!: VizHeaderMenusConfig;

    constructor() {
        super();
    }

    ngOnInit() {
        this.configureBrandLink();
        this.buildMenus();
    }

    configureBrandLink() {
        this.brandLink = '/registration';
    }

    buildMenus() {
        this.headerMenus = {
            help: {
                items: [
                    { menuItemText: HELP_EMAIL_ITEM_TEXT, icon: HELP_ICON },
                    { menuItemText: HELP_RESOURCES_ITEM_TEXT, icon: HELP_ICON }
                ]
            },
            apps: {
                items: [
                    { menuItemText: BID_REGISTRATION_ITEM_TEXT, icon: APPS_ICON }
                ]
            }
        };
    }

    onHelpItemSelected(event: VizHeaderMenuItemSelectedEvent) {
        switch (event.item.menuItemText) {
            case HELP_EMAIL_ITEM_TEXT:
                this.openUrl(`mailto:${SUPPORT_EMAIL}`, '_self');
                break;
            case HELP_RESOURCES_ITEM_TEXT:
                this.openUrl('https://www.vizientinc.com/who-we-serve/suppliers');
                break;
            default:
                break;
        }
    }

    onAppsItemSelected(event: VizHeaderMenuItemSelectedEvent) {
        switch (event.item.menuItemText) {
            case BID_REGISTRATION_ITEM_TEXT:
                this.router.navigate(['/registration']);
                break;
            default:
                break;
        }
    }

    onUserItemSelected(_: VizHeaderMenuItemSelectedEvent) {}

    openUrl(url: string, target: '_self' | '_blank' = '_blank') {
        window.open(url, target, 'noopener,noreferrer');
    }
}
